import { isNotEmpty } from 'ramda-extension';

import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { getLabelMessage } from '@gef-ui/localization/messages';

export default createValidationFn(({ fileNameMaxLength }) => ({ fieldValue }) => {
	if (fieldValue?.length > 0) {
		let result;
		// eslint-disable-next-line
		result = fieldValue
			.map(({ name: fileName }, index) => {
				const [name] = fileName.split('.');
				if (name.length > fileNameMaxLength) {
					return {
						messageKey: getLabelMessage('validation:fileNameExceededMaxLength', {
							fileName,
							fileNameMaxLength,
						}),
						index,
					};
				}
				return undefined;
			})
			.filter((file) => file);
		return { messageKey: isNotEmpty(result) ? 'emptyError' : false, metaInfo: result };
	}
});
